// services/animeService.js
import axios from 'axios';

export const fetchAnimeByGenre = async (genreId) => {
  try {
    const res = await axios.get(`https://api.jikan.moe/v4/anime?genres=22&limit=10`);
    return res.data.data;
  } catch (error) {
    console.error("Error fetching anime:", error);
    return [];
  }
};
